import React from 'react';
import { TrolleyContextValue } from './types';

const TrolleyContext = React.createContext<TrolleyContextValue | undefined>(undefined);

export default TrolleyContext;
